import React, { useEffect, useState } from 'react'

import { useLogout, useTitle, CanAccess, ITreeMenu, useNavigation, useGetIdentity, useList } from '@pankod/refine-core'
import { AntdLayout, Menu, Grid, Icons, useMenu, Button } from '@pankod/refine-antd'

import { antLayoutSider, antLayoutSiderMobile } from './styles'
import './sider.less'

import Permissions, { grantList } from 'permissions'
import { useUserContext } from 'context/user'
import { useLayoutContext } from 'context/layout'
import { accessList, transformPermissionObjectToArray } from 'helpers'
import CentaFirstLetter from '../../../assets/centa_C_logo.png'

const {
  UnorderedListOutlined,
  SettingOutlined,
  FileDoneOutlined,
  ReadOutlined,
  CheckCircleOutlined,
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
} = Icons

export const Sider: React.FC = () => {
  const { sidebarCollapsed, setSidebarCollapsed } = useLayoutContext()

  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const { userRole, resetUserContext } = useUserContext()

  const { mutate: logout } = useLogout()
  const Title = useTitle()
  const { SubMenu } = Menu

  const { menuItems, selectedKey, defaultOpenKeys } = useMenu()
  const { push } = useNavigation()
  const breakpoint = Grid.useBreakpoint()

  const isMobile = !breakpoint.lg

  const renderTreeView = (tree: ITreeMenu[], selectedKey: string) => {
    return tree.map((item: ITreeMenu) => {
      const { icon, label, route, name, children, parentName } = item

      if (children.length > 0) {
        return (
          <SubMenu key={name} icon={icon ?? <UnorderedListOutlined />} title={label}>
            {renderTreeView(children, selectedKey)}
          </SubMenu>
        )
      }
      const isSelected = route === selectedKey
      const isRoute = !(parentName !== undefined && children.length === 0)
      return (
        <CanAccess key={route} resource={name.toLowerCase()} action="list">
          <Menu.Item
            key={selectedKey}
            onClick={() => {
              push(route ?? '')
            }}
            style={{
              fontWeight: isSelected ? 'bold' : 'normal',
            }}
            icon={icon ?? (isRoute && <UnorderedListOutlined />)}
          >
            {label}
            {!sidebarCollapsed && isSelected && <div className="ant-menu-tree-arrow" />}
          </Menu.Item>
        </CanAccess>
      )
    })
  }
  // permissions
  const { isLoading } = useList<any>({
    resource: 'permissions',
    liveMode: 'auto',
    config: {
      filters: [
        {
          field: 'support_id',
          operator: 'eq',
          value: user?.id,
        },
        {
          field: 'active',
          operator: 'eq',
          value: true,
        },
      ],
    },
    metaData: {
      fields: ['id', 'can_read', 'can_create', 'can_update', 'can_delete', 'support_id', { module: ['label', 'value'] }],
    },
    queryOptions: {
      enabled: userRole === 'systemsupport',
      onSuccess(data) {
        const res = data?.data
        console.log('response_support', res)
        let access: any = []
        for (let i = 0; i < res?.length; i++) {
          const info = transformPermissionObjectToArray(res[i])
          access?.push(...info)
        }
        console.log('response_access', access)
        const filter_access = access?.filter((f: any) => f?.action !== '')
        const support_access = accessList?.filter((s: any) => s?.role === userRole)
        console.log('response_support', filter_access)
        console.log('response_support_grant_list', grantList)
        // Permissions.setGrants([...support_access, ...access])
        const grant_object: any[] = [...grantList, ...filter_access]
        console.log('response_grant_object', grant_object)
        Permissions.setGrants(grant_object)
      },
    },
  })
  console.log(Permissions.getGrants(), 'response_support_check', userRole)
  return (
    <AntdLayout.Sider
      className="ams-sider"
      trigger={null}
      collapsible
      // collapsed={collapsed}
      collapsed={sidebarCollapsed}
      // onCollapse={(collapsed: boolean): void => setCollapsed(collapsed)}
      onCollapse={(collapsed: boolean): void => setSidebarCollapsed(collapsed)}
      collapsedWidth={isMobile ? 45 : 0}
      breakpoint="lg"
      style={isMobile ? antLayoutSiderMobile : antLayoutSider}
      width={260}
    >
      {/* {isMobile && (
        <div className="hamburger-menu" onClick={toggleSidebar} style={{display:'flex',justifyContent:'center',marginTop:'2rem'}}>
          <div className="hamburger-icon" style={{fontSize:'25px',cursor:'pointer'}}>&#9776;</div>
        </div>
      )} */}

      {!isMobile ? (
        Title && (
          <div className="ams-sider-brand">
            <Title collapsed={sidebarCollapsed} />
          </div>
        )
      ) : (
        <div className="ams-sider-brand hamburger-menu">
          <img src={CentaFirstLetter} alt="Centa" style={{ width: '35px', height: '35px' }} />
        </div>
      )}

      <Menu
        className="ams-sider-menu"
        theme="light"
        selectedKeys={[selectedKey]}
        defaultOpenKeys={defaultOpenKeys}
        mode="inline"
        onClick={({ key }) => {
          if (key === 'logout') {
            logout()
            resetUserContext()
            return
          }

          if (!breakpoint.lg) {
            setSidebarCollapsed(true)
          }

          push(key as string)
        }}
      >
        {/*} {renderTreeView(menuItems, selectedKey)}*/}

        {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('dashboard').granted ? (
          <Menu.Item
            icon={<DashboardOutlined />}
            key="/"
            onClick={() => {
              push('/')
            }}
            style={{
              fontWeight: selectedKey === '/' ? 'bold' : 'normal',
            }}
          >
            Dashboard
          </Menu.Item>
        ) : null}

        {userRole !== '' &&
        userRole !== undefined &&
        // userRole !== 'papersetter' &&
        (Permissions.can(userRole).readAny('work_requests').granted || Permissions.can(userRole).readAny('questions').granted) ? (
          <Menu.SubMenu
            key="question bank"
            title={
              userRole === 'qbincharge'
                ? 'Question Bank'
                : userRole === 'qapprover'
                ? 'Question Approval'
                : userRole === 'qreviewer'
                ? 'Question Reviewal'
                : 'Question Creation'
            }
            icon={<ReadOutlined />}
          >
            {userRole && Permissions.can(userRole).readAny('work_requests').granted && userRole !== 'papersetter' ? (
              <Menu.Item
                key="/work_requests"
                onClick={() => {
                  push('/work_requests')
                }}
                style={{
                  fontWeight: selectedKey === '/work_requests' ? 'bold' : 'normal',
                }}
              >
                Work Requests
              </Menu.Item>
            ) : null}
            {/* {userRole && Permissions.can(userRole).readAny('questions').granted && userRole !== 'paperapprover' ? (
              <Menu.Item
                key="/questions"
                onClick={() => {
                  push('/questions')
                }}
                style={{
                  fontWeight: selectedKey === '/questions' ? 'bold' : 'normal',
                }}
              >
                Questions
              </Menu.Item>
            ) : null} */}
            {userRole && Permissions.can(userRole).readAny('questions').granted && userRole !== 'paperapprover' ? (
              <Menu.Item
                key="/all-questions"
                onClick={() => {
                  push('/all-questions')
                }}
                style={{
                  fontWeight: selectedKey === '/all-questions' ? 'bold' : 'normal',
                }}
              >
                All Questions
              </Menu.Item>
            ) : null}
            {userRole && Permissions.can(userRole).readAny('retired_questions').granted ? (
              <Menu.Item
                key="/retired_questions"
                onClick={() => {
                  push('/retired_questions')
                }}
                style={{
                  fontWeight: selectedKey === '/retired_questions' ? 'bold' : 'normal',
                }}
              >
                Auto Retired Questions
              </Menu.Item>
            ) : null}

            {/* {userRole && Permissions.can(userRole).readAny('uploaded_questions').granted ? (
              <Menu.Item
                key="/uploaded_questions"
                onClick={() => {
                  push('/uploaded_questions')
                }}
                style={{
                  fontWeight: selectedKey === '/uploaded_questions' ? 'bold' : 'normal',
                }}
              >
                Upload Questions
              </Menu.Item>
            ) : null} */}
            {userRole && Permissions.can(userRole).readAny('draft_questions').granted ? (
              <Menu.Item
                key="/draft_questions"
                onClick={() => {
                  push('/draft_questions')
                }}
                style={{
                  fontWeight: selectedKey === '/draft_questions' ? 'bold' : 'normal',
                }}
              >
                Draft Questions
              </Menu.Item>
            ) : null}
            {userRole && Permissions.can(userRole).readAny('cleanup').granted ? (
              <Menu.Item
                key="/cleanup"
                onClick={() => {
                  push('/cleanup')
                }}
                style={{
                  fontWeight: selectedKey === '/cleanup' ? 'bold' : 'normal',
                }}
              >
                Question Cleanup
              </Menu.Item>
            ) : null}
          </Menu.SubMenu>
        ) : null}

        {userRole &&
        (Permissions.can(userRole).readAny('products').granted ||
          Permissions.can(userRole).readAny('test_tracks').granted ||
          Permissions.can(userRole).readAny('paper_templates').granted ||
          Permissions.can(userRole).readAny('papers').granted) ? (
          <Menu.SubMenu key="paper setting" title="Paper Setting" icon={<FileDoneOutlined />}>
            {userRole && Permissions.can(userRole).readAny('products').granted ? (
              <Menu.Item
                key="/products"
                onClick={() => {
                  push('/products')
                }}
                style={{
                  fontWeight: selectedKey === '/products' ? 'bold' : 'normal',
                }}
              >
                Products
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('test_tracks').granted ? (
              <Menu.Item
                key="/test_tracks"
                onClick={() => {
                  push('/test_tracks')
                }}
                style={{
                  fontWeight: selectedKey === '/test_tracks' ? 'bold' : 'normal',
                }}
              >
                Test Tracks
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('paper_templates').granted ? (
              <Menu.Item
                key="/paper_templates"
                onClick={() => {
                  push('/paper_templates')
                }}
                style={{
                  fontWeight: selectedKey === '/paper_templates' ? 'bold' : 'normal',
                }}
              >
                Paper Templates
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('paper_requests').granted ? (
              <Menu.Item
                key="/paper_requests"
                onClick={() => {
                  push('/paper_requests')
                }}
                style={{
                  fontWeight: selectedKey === '/paper_requests' ? 'bold' : 'normal',
                }}
              >
                Paper Requests
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('papers').granted ? (
              <Menu.Item
                key="/papers"
                onClick={() => {
                  push('/papers')
                }}
                style={{
                  fontWeight: selectedKey === '/papers' ? 'bold' : 'normal',
                }}
              >
                Papers
              </Menu.Item>
            ) : null}
          </Menu.SubMenu>
        ) : null}
        {userRole !== '' &&
        userRole !== undefined &&
        (Permissions.can(userRole).readAny('test_events').granted ||
          Permissions.can(userRole).readAny('candidates').granted ||
          Permissions.can(userRole).readAny('evaluation_requests').granted ||
          Permissions.can(userRole).readAny('tests').granted ||
          Permissions.can(userRole).readAny('evaluations').granted ||
          Permissions.can(userRole).readAny('exam_online_ingest_jobs').granted) ? (
          <Menu.SubMenu key="results" title="Results" icon={<CheckCircleOutlined />}>
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('evaluations').granted ? (
              <Menu.Item
                key="/evaluations"
                onClick={() => {
                  push('/evaluations')
                }}
                style={{
                  fontWeight: selectedKey === '/evaluations' ? 'bold' : 'normal',
                }}
              >
                Evaluations
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('evaluation_requests').granted ? (
              <Menu.Item
                key="/evaluation_requests"
                onClick={() => {
                  push('/evaluation_requests')
                }}
                style={{
                  fontWeight: selectedKey === '/evaluation_requests' ? 'bold' : 'normal',
                }}
              >
                Evaluation Requests
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('test_events').granted ? (
              <Menu.Item
                key="/test_events"
                onClick={() => {
                  push('/test_events')
                }}
                style={{
                  fontWeight: selectedKey === '/test_events' ? 'bold' : 'normal',
                }}
              >
                Test Events
              </Menu.Item>
            ) : null}

            {/* centa */}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('national_average').granted ? (
              <Menu.Item
                key="/nationalaverage"
                onClick={() => {
                  push('/nationalaverage')
                }}
                style={{
                  fontWeight: selectedKey === '/test_events' ? 'bold' : 'normal',
                }}
              >
                National Average
              </Menu.Item>
            ) : null}
            {/* ---------------------------end----------------------------- */}

            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('candidates').granted ? (
              <Menu.Item
                key="/candidates"
                onClick={() => {
                  push('/candidates')
                }}
                style={{ fontWeight: selectedKey === '/candidates' ? 'bold' : 'normal' }}
              >
                Candidates
              </Menu.Item>
            ) : null}
            {userRole !== '' &&
            userRole !== undefined &&
            Permissions.can(userRole).readAny('exam_online_ingest_jobs').granted ? (
              <Menu.Item
                key="/exam-online"
                onClick={() => {
                  push('/exam-online')
                }}
                style={{ fontWeight: selectedKey === '/exam-online' ? 'bold' : 'normal' }}
              >
                Exam Online
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('tests').granted ? <Menu.Item>Tests</Menu.Item> : null}
          </Menu.SubMenu>
        ) : null}
        {userRole !== '' &&
        userRole !== undefined &&
        (Permissions.can(userRole).readAny('mediums').granted ||
          Permissions.can(userRole).readAny('grade_levels').granted ||
          Permissions.can(userRole).readAny('grades').granted ||
          Permissions.can(userRole).readAny('subjects').granted ||
          Permissions.can(userRole).readAny('themes').granted ||
          Permissions.can(userRole).readAny('sub_themes').granted ||
          Permissions.can(userRole).readAny('topics').granted ||
          Permissions.can(userRole).readAny('report_themes').granted ||
          Permissions.can(userRole).readAny('sections').granted ||
          Permissions.can(userRole).readAny('competencies').granted ||
          Permissions.can(userRole).readAny('competency_aspects').granted) ? (
          <Menu.SubMenu key="setup" title="Setup" icon={<SettingOutlined />}>
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('ai_configurations').granted ? (
              <Menu.Item
                key="/aiconfig"
                onClick={() => {
                  push('/aiconfig')
                }}
                style={{
                  fontWeight: selectedKey === '/retire_rules' ? 'bold' : 'normal',
                }}
              >
                Ai Config
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('mediums').granted ? (
              <Menu.Item
                key="/mediums"
                onClick={() => {
                  push('/mediums')
                }}
                style={{
                  fontWeight: selectedKey === '/mediums' ? 'bold' : 'normal',
                }}
              >
                Medium
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('blooms_levels').granted ? (
              <Menu.Item
                key="/blooms_levels"
                onClick={() => {
                  push('/blooms_levels')
                }}
                style={{
                  fontWeight: selectedKey === '/blooms_levels' ? 'bold' : 'normal',
                }}
              >
                Bloom's Levels
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('difficulty_levels').granted ? (
              <Menu.Item
                key="/difficulty_levels"
                onClick={() => {
                  push('/difficulty_levels')
                }}
                style={{
                  fontWeight: selectedKey === '/difficulty_levels' ? 'bold' : 'normal',
                }}
              >
                Difficulty Levels
              </Menu.Item>
            ) : null}

            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('grade_levels').granted ? (
              <Menu.Item
                key="/grade_levels"
                onClick={() => {
                  push('/grade_levels')
                }}
                style={{
                  fontWeight: selectedKey === '/grade_levels' ? 'bold' : 'normal',
                }}
              >
                Grade Levels
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('grades').granted ? (
              <Menu.Item
                key="/grades"
                onClick={() => {
                  push('/grades')
                }}
                style={{
                  fontWeight: selectedKey === '/grades' ? 'bold' : 'normal',
                }}
              >
                Grades
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('subjects').granted ? (
              <Menu.Item
                key="/subjects"
                onClick={() => {
                  push('/subjects')
                }}
                style={{
                  fontWeight: selectedKey === '/subjects' ? 'bold' : 'normal',
                }}
              >
                Subjects
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('themes').granted ? (
              <Menu.Item
                key="/themes"
                onClick={() => {
                  push('/themes')
                }}
                style={{
                  fontWeight: selectedKey === '/themes' ? 'bold' : 'normal',
                }}
              >
                Themes
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('sub_themes').granted ? (
              <Menu.Item
                key="/sub_themes"
                onClick={() => {
                  push('/sub_themes')
                }}
                style={{
                  fontWeight: selectedKey === '/subthemes' ? 'bold' : 'normal',
                }}
              >
                Sub-Themes
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('topics').granted ? (
              <Menu.Item
                key="/topics"
                onClick={() => {
                  push('/topics')
                }}
                style={{
                  fontWeight: selectedKey === '/topics' ? 'bold' : 'normal',
                }}
              >
                Topics
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('report_themes').granted ? (
              <Menu.Item
                key="/report_themes"
                onClick={() => {
                  push('/report_themes')
                }}
                style={{
                  fontWeight: selectedKey === '/report_themes' ? 'bold' : 'normal',
                }}
              >
                Report Themes
              </Menu.Item>
            ) : null}
            {/* project setup */}
            {/* {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('project-setup').granted ? (
              <Menu.Item
                key="/project-setup"
                onClick={() => {
                  push('/project-setup')
                }}
                style={{
                  fontWeight: selectedKey === '/project-setup' ? 'bold' : 'normal',
                }}
              >
                Project Setup
              </Menu.Item>
            ) : null} */}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('sections').granted ? (
              <Menu.Item
                key="/sections"
                onClick={() => {
                  push('/sections')
                }}
                style={{
                  fontWeight: selectedKey === '/sections' ? 'bold' : 'normal',
                }}
              >
                Sections
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('competencies').granted ? (
              <Menu.Item
                key="/competencies"
                onClick={() => {
                  push('/competencies')
                }}
                style={{
                  fontWeight: selectedKey === '/competencies' ? 'bold' : 'normal',
                }}
              >
                Competencies
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('tn_taxonomys').granted ? (
              <Menu.Item
                key="/tn_taxonomys"
                onClick={() => {
                  push('/tn_taxonomys')
                }}
                style={{
                  fontWeight: selectedKey === '/tn_taxonomys' ? 'bold' : 'normal',
                }}
              >
                Taxonomy
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('teacher_levels').granted ? (
              <Menu.Item
                key="/teacher_levels"
                onClick={() => {
                  push('/teacher_levels')
                }}
                style={{
                  fontWeight: selectedKey === '/teacher_levels' ? 'bold' : 'normal',
                }}
              >
                Teacher Level
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('strands').granted ? (
              <Menu.Item
                key="/strands"
                onClick={() => {
                  push('/strands')
                }}
                style={{
                  fontWeight: selectedKey === '/strands' ? 'bold' : 'normal',
                }}
              >
                Standard
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('check_lists').granted ? (
              <Menu.Item
                key="/check_lists"
                onClick={() => {
                  push('/check_lists')
                }}
                style={{
                  fontWeight: selectedKey === '/check_lists' ? 'bold' : 'normal',
                }}
              >
                Check Lists
              </Menu.Item>
            ) : null}
            {/* {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('competency_aspects').granted ? (
              <Menu.Item
                key="/competency_aspects"
                onClick={() => {
                  push('/competency_aspects')
                }}
                style={{
                  fontWeight: selectedKey === '/competency_aspects' ? 'bold' : 'normal',
                }}
              >
                Competency Aspects
              </Menu.Item>
            ) : null} */}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('centa_concepts').granted ? (
              <Menu.Item
                key="/centa_concepts"
                onClick={() => {
                  push('/centa_concepts')
                }}
                style={{
                  fontWeight: selectedKey === '/centa_concepts' ? 'bold' : 'normal',
                }}
              >
                Centa Concept
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('explanation_types').granted ? (
              <Menu.Item
                key="/explanation_types"
                onClick={() => {
                  push('/explanation_types')
                }}
                style={{
                  fontWeight: selectedKey === '/explanation_type' ? 'bold' : 'normal',
                }}
              >
                Explanation Type
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('retire_rules').granted ? (
              <Menu.Item
                key="/retire_rules"
                onClick={() => {
                  push('/retire_rules')
                }}
                style={{
                  fontWeight: selectedKey === '/retire_rules' ? 'bold' : 'normal',
                }}
              >
                Auto Rules
              </Menu.Item>
            ) : null}
            {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('configurations').granted ? (
              <Menu.Item
                key="/configurations"
                onClick={() => {
                  push('/configurations')
                }}
                style={{
                  fontWeight: selectedKey === '/config' ? 'bold' : 'normal',
                }}
              >
                Configurations
              </Menu.Item>
            ) : null}
          </Menu.SubMenu>
        ) : null}

        {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('report').granted ? (
          <Menu.SubMenu key="report" title="Reports" icon={<UserOutlined />}>
            <Menu.Item
              key="/report"
              onClick={() => {
                push('/report')
              }}
              style={{
                fontWeight: selectedKey === '/report' ? 'bold' : 'normal',
              }}
            >
              Report
            </Menu.Item>
          </Menu.SubMenu>
        ) : null}
        {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('users').granted ? (
          <Menu.SubMenu key="user" title="User" icon={<UserOutlined />}>
            <Menu.Item
              key="/users"
              onClick={() => {
                push('/users')
              }}
              style={{
                fontWeight: selectedKey === '/users' ? 'bold' : 'normal',
              }}
            >
              All Users
            </Menu.Item>
          </Menu.SubMenu>
        ) : null}
        {/* {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('question_history').granted ? (
          <Menu.SubMenu key="question_history" title="History Logs" icon={<UserOutlined />}>
            <Menu.Item
              key="/question_history"
              onClick={() => {
                push('/question_history')
              }}
              style={{
                fontWeight: selectedKey === '/question_history' ? 'bold' : 'normal',
              }}
            >
              Question Logs
            </Menu.Item>
          </Menu.SubMenu>
        ) : null} */}
        {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('support_tasks').granted ? (
          <Menu.SubMenu key="system_supports" title="System Supports" icon={<UserOutlined />}>
            <Menu.Item
              key="/support/tasks"
              onClick={() => {
                push('/support/tasks')
              }}
              style={{
                fontWeight: selectedKey === '/support/tasks' ? 'bold' : 'normal',
              }}
            >
              Support Tasks
            </Menu.Item>
          </Menu.SubMenu>
        ) : null}
        {userRole !== '' && userRole !== undefined && Permissions.can(userRole).readAny('tasks').granted ? (
          <Menu.Item
            icon={<DashboardOutlined />}
            key="/tasks"
            onClick={() => {
              push('/tasks')
            }}
            style={{
              fontWeight: selectedKey === '/tasks' ? 'bold' : 'normal',
            }}
          >
            Tasks
          </Menu.Item>
        ) : null}
        <Menu.Item
          key="logout"
          icon={<LogoutOutlined />}
          onClick={({ key }) => {
            logout()
            resetUserContext()
            return
          }}
        >
          Logout
        </Menu.Item>
      </Menu>
    </AntdLayout.Sider>
  )
}
